// utils/axios.js
import axios from "axios";
import config from "../config";

// 配置API基础URL
const API_BASE_URL = config.API_BASE_URL;

axios.interceptors.request.use(axiosConfig => {
    const token = localStorage.getItem(config.STORAGE_KEYS.ACCESS_TOKEN);
    if (token) {
        axiosConfig.headers.Authorization = `Bearer ${token}`;
    }
    return axiosConfig;
});

axios.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;
        console.log()

        // 如果是 401 且不是刷新 Token 的请求
        if (error.response?.status === 401 && !originalRequest._retry) {
            const refresh_token = localStorage.getItem(config.STORAGE_KEYS.REFRESH_TOKEN);
            localStorage.removeItem(config.STORAGE_KEYS.ACCESS_TOKEN);

            if (!refresh_token) {
                // 没有refresh_token，直接跳转登录
                localStorage.removeItem(config.STORAGE_KEYS.REFRESH_TOKEN);
                window.location.href = '/login';
                return Promise.reject(error);
            }

            originalRequest._retry = true;

            try {
                // 用 refresh_token 获取新 access_token
                const url = `${API_BASE_URL}/api/user/refresh`;
                const refreshConfig = {
                    headers: {
                        authorization: `Bearer ${refresh_token}`
                    },
                    timeout: 10000 // 10秒超时
                };
                
                const res = await axios.post(url, {}, refreshConfig);
                console.log(res);
                // 检查响应数据
                if (res.data && res.data.access_token) {
                    // 更新存储的 Token
                    localStorage.setItem(config.STORAGE_KEYS.ACCESS_TOKEN, res.data.access_token);
                    
                    // 如果响应中包含新的refresh_token，也更新它
                    if (res.data.refresh_token) {
                        localStorage.setItem(config.STORAGE_KEYS.REFRESH_TOKEN, res.data.refresh_token);
                    }

                    // 重试原始请求
                    originalRequest.headers.Authorization = `Bearer ${res.data.access_token}`;
                    return axios(originalRequest);
                } else {
                    throw new Error('Invalid refresh response');
                }
            } catch (refreshError) {
                console.error('Token refresh failed:', refreshError);
                
                // 清除所有token并跳转到登录页
                localStorage.removeItem(config.STORAGE_KEYS.ACCESS_TOKEN);
                localStorage.removeItem(config.STORAGE_KEYS.REFRESH_TOKEN);
                window.location.href = '/login';
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default axios;
